import { IVendorIndustries } from 'types/graphqlTypes'
import { DISPLAY } from 'constants/display'

export const industryOptions = [
  {
    label: DISPLAY.empty,
    value: '',
  },
  {
    label: 'Commercial, Industrial and Automotive',
    value: IVendorIndustries.COMMERCIAL_INDUSTRIAL_AUTOMOTIVE,
  },
  {
    label: 'CPG',
    value: IVendorIndustries.CPG,
  },
  {
    label: 'Food and Beverages',
    value: IVendorIndustries.FOOD_AND_BEV,
  },
  {
    label: 'Retail',
    value: IVendorIndustries.RETAIL,
  },
]
